import * as tslib_1 from "tslib";
import { ANCHOR_TAG_NAME, IMG_TAG_NAME } from './constants';
import processAnchorElements, { AnchorElementsSource } from './processAnchorElements';
import { isAttachmentFeatureEnabled } from 'owa-attachment-feature-flags';
import { trace } from 'owa-trace';
export default function handleBeforePasteEvent(event, linkPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var links, images;
        return tslib_1.__generator(this, function (_a) {
            if (!isAttachmentFeatureEnabled('doc-sharingTips-linkRemove') ||
                event.pasteOption !== 0 /* PasteHtml */) {
                return [2 /*return*/];
            }
            trace.info('handleBeforePasteEvent');
            links = event.fragment.querySelectorAll(ANCHOR_TAG_NAME);
            images = event.fragment.querySelectorAll(IMG_TAG_NAME);
            processAnchorElements(links, null, AnchorElementsSource.PasteHtml, linkPlugin, viewState, parentItemIdWrapper, infoBarAddHandler, infoBarRemoveHandler, processedLinkIds, images.length);
            return [2 /*return*/];
        });
    });
}
//# sourceMappingURL=handleBeforePasteEvent.js.map